import { useMemo } from 'react';
import { AnalysisSummary, AnalysisStatus } from '@/api/domains/analyses/types';

interface UseFilteredAnalysesProps {
  analyses: AnalysisSummary[] | undefined;
  statusFilter: AnalysisStatus | 'all';
  searchQuery: string;
}

export const useFilteredAnalyses = ({
  analyses,
  statusFilter,
  searchQuery
}: UseFilteredAnalysesProps) => {
  return useMemo(() => {
    if (!analyses) return [];

    const byStatus =
      statusFilter === 'all'
        ? analyses
        : analyses.filter(
            (analysis) =>
              analysis.status === (statusFilter.toUpperCase() as AnalysisStatus)
          );

    const query = searchQuery.trim().toLowerCase();
    if (!query) return byStatus;

    return byStatus.filter((analysis) => {
      const doc1 = analysis.document_1_id?.toLowerCase() || '';
      const doc2 = analysis.document_2_id?.toLowerCase() || '';
      const name = analysis.analysis_name?.toLowerCase() || '';
      const status = analysis.status?.toLowerCase() || '';

      return (
        name.includes(query) ||
        doc1.includes(query) ||
        doc2.includes(query) ||
        status.includes(query)
      );
    });
  }, [analyses, statusFilter, searchQuery]);
};
